import { useEffect, useState } from 'react'
import './styles/AnalisisModal.css'
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import LoadSimple from '../LoadSimple'
import LoadAlerts from '../LoadAlerts';
import InternalError from '../generales/InternalError';
import { capitalizeFirstLetter } from '../../utils/utils';
import { lang } from '../generales/traduction';
import Action from '../Action';
import Modal from 'react-modal';
import ResetModal from '../ResetModal';
import { useFetch } from '../../hooks/useFetch';
import SelectorAdmin from '../SelectorAdmin';
const customStylesAnalisis = {
  content: {
    top: '50%',
    left: '50%',
    background: 'transparent',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '40%',
    height: '30%',
    padding: '20px',
    border: 'unset'
  },
};
const MenuResetModal = ({ eventId, handleShowPopup, props, isOpen, data, statusPing, closeActionModal, }) => {
  const token_item = localStorage.getItem('access_token')
  const [internalError, setInternalError] = useState(false)
  const [dataAnalisis, setDataAnalisis] = useState({ data: [], loading: true, error: null })

  const [dataPing, setDataPing] = useState({ data: [], loading: false, error: null })
  const [ejecuta, setEjecuta] = useState(false)
  const [pingModalOpen, setPingModalOpen] = useState(false);
  const dataCatalog = useFetch('cassia/resets/reset_pmi/device_catalog', '', '', 'GET', props.server)
  const dataResetDown = useFetch('cassia/resets/down_resets_30m', '', '', 'GET', props.server)
  const [responseData, setResponseData] = useState({ active: false, data: {} })

  let blockData = null;
  if (!dataResetDown.loading && dataResetDown.data) {
    let list = [];
    if (Array.isArray(dataResetDown.data)) {
      list = dataResetDown.data;
    } else if (dataResetDown.data.data && Array.isArray(dataResetDown.data.data)) {
      list = dataResetDown.data.data;
    }
    const found = list.find(item => item.affiliation === data.affiliation);
    if (found && found.down_time_minutes < 30) {
      blockData = {
        down_minutes: found.down_time_minutes,
        remaining_minutes: 35 - found.down_time_minutes
      };
    } else {}
  }

  function openPingModal() {
    // if (blockData) return;
    setPingModalOpen(true);
  }

  function closePingModal() {
    setPingModalOpen(false);
  }
  useEffect(() => {
    search_event()
  }, [])
  function search_event() {
    setDataAnalisis({ data: {}, loading: true, error: dataAnalisis.error })
    const fetchData = async () => {
      // console.log(props.server.url+'/api/v1/cassia/diagnosta/'+props.data.ip)
      try {
        const response = await fetch(props.server.url + '/api/v1/cassia/diagnosta/' + props.data.ip, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token_item}`,
          },
        });
        if (response.ok) {
          const response_data = await response.json();

          setDataAnalisis({ data: response_data.data, loading: false, error: dataAnalisis.error })

          // setDataAnalisis(response_data.data)
        } else {
          throw new Error('Error en la solicitud');
        }
      } catch (error) {
        setInternalError(true)
      }
    };
    fetchData();
  }
  const obtenerFechaActualLocal = () => {
    const ahora = new Date();
    const anio = ahora.getFullYear();
    const mes = String(ahora.getMonth() + 1).padStart(2, '0'); // El mes se cuenta desde 0
    const dia = String(ahora.getDate()).padStart(2, '0');
    const horas = String(ahora.getHours()).padStart(2, '0');
    const minutos = String(ahora.getMinutes()).padStart(2, '0');

    return `${anio}-${mes}-${dia}_${horas}-${minutos}`;
  };
  const generatePDF = () => {

    const input = document.getElementById('bodyContAnalisisModal');

    // Guardar el estado actual de visibilidad de los elementos que deseas ocultar
    const originalDisplay = [];
    const elementsToHide = input.querySelectorAll('.contRowTableAnalisis');
    elementsToHide.forEach(element => {
      originalDisplay.push(element.style.color);
      element.style.color = 'black';
    });

    html2canvas(input)
      .then((canvas) => {
        // Restaurar el estado original de visibilidad
        elementsToHide.forEach((element, index) => {
          element.style.color = originalDisplay[index];
        });

        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF();
        pdf.addImage(imgData, 'PNG', 10, 10, 190, 100);
        pdf.save('diagnosta-' + eventId + '-' + obtenerFechaActualLocal() + '.pdf');
      });
  }
  const Ejecutar = () => {
    setEjecuta(true)
    const obj = {
      affiliation: data.affiliation,
      hostid: data.hostid
    }
    let method = 'POST'
    // setLoading(true)
    setDataPing({ data: dataPing.data, loading: true, error: null })
    const fetchDataPost = async () => {

      try {
        // console.log(localStorage.getItem('access_token'))
        const response = await fetch(props.server.url + '/api/v1/cassia/resets/reset_pmi?affiliation=' + data.affiliation, {
          // const response = await fetch(server.url+'/api/v1/zabbix/hosts/actionz/'+ip+'/-1', {
          method: method,
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          },
          // body:JSON.stringify(obj)

        });
        if (response.ok) {
          const data1 = await response.json();
          setDataPing(data1)
          // if(!isOpen){
          handleShowPopup(((data1.success) ? 'Completado' : 'Error!!!'), data1.success ? ' ' + data1.message + ' al dispositivo "' + data.affiliation + '" ' :
            (' RESET al dispositivo "' + data.affiliation + '" ejecutada sin exitó', (data1.success) ? '' : data1.message), data1.success ? true : false)
          // }
          setDataPing({ data: data1, loading: false, error: null })
        } else {
          setDataPing({ data: dataPing.data, loading: false, error: null })
          throw new Error('Error en la solicitud');
        }
      } catch (error) {
        setDataPing({ data: dataPing.data, loading: false, error: null })
        console.error(error);

        handleShowPopup('Error!!!', '  RESET al dispositivo "' + data.affiliation + '" ejecutada sin exitó', 'Favor de reportar el error', false)

      }
    };

    // fetchDataPost();
  }
  const [techType, setTechType] = useState({ filter: "period", value: 0, label: "", id: 0 })
  const changeOption = (option, index) => {
    setTechType(option)
  }
  const [byHost, setByHost] = useState(true)
  return (
    (internalError) ?
      <InternalError /> :
      <>
        <div className='contAnalisisModal'>
          <div className='headContAnalisisModal'>
            {'Analisis de dispositivos relacionados'}: {eventId}
            <div className='imgCardTitleMin' style={{ left: '90%' }}>
              {/* <div className='imgContent' onClick={()=>{ generatePDF()}}>
                              <img  style={{top:'15%',height:'100%'}}src={"/iconos/download.png"}  className="expandLogo expandLogoD" alt="Logo" />
                              </div> */}
            </div>
          </div>

          <div className='bodyContAnalisisModal' id='bodyContAnalisisModal'>
            {
              (dataAnalisis.loading || dataResetDown.loading) ? <div className='contflujoload'><LoadAlerts languaje={props.languaje} /></div> :
                  <>

                    <div className='contTableAnalisis'>
                      <div className='contInfoHostAnalisis'>
                        <div className='contRowTableAnalisis' style={{ background: 'transparent', fontSize: 'var(--font-size-small)' }}>
                          {capitalizeFirstLetter(lang[props.languaje]['dataHostDiag'])}
                        </div>
                        <div className='contRowTableAnalisis' style={{ background: 'transparent' }}>
                          <p style={{ fontSize: 'var(--font-size-small)', color: 'var(--main-color)' }}>{capitalizeFirstLetter(lang[props.languaje]['dispositivo'])}:</p>&nbsp; &nbsp; &nbsp; {props.data.Host} &nbsp; &nbsp; &nbsp; <p style={{ color: 'var(--green)', fontSize: 'var(--font-size-med)' }}>&nbsp;&nbsp;{(props.data.tipo == 1) ? 'ODD' : ''}</p>
                        </div>
                        <div className='contRowTableAnalisis' style={{ background: 'transparent' }}>
                          <div className='controwCellTableanalisis' style={{ width: '50%' }}>
                            <p style={{ fontSize: 'var(--font-size-small)', color: 'var(--main-color)' }}>{capitalizeFirstLetter(lang[props.languaje]['problema'])}:&nbsp; </p> {props.data.Problem}
                          </div>
                          <div className='controwCellTableanalisis' style={{ width: '50%' }}>
                            <p style={{ fontSize: 'var(--font-size-small)', color: 'var(--main-color)' }}>IP&nbsp; :</p> {props.data.ip}
                          </div>

                        </div>
                        <div className='contRowTableAnalisis' style={{ fontSize: 'var(--font-size-small)', background: 'transparent' }}>
                          {capitalizeFirstLetter(lang[props.languaje]['arrastreHostDependientes'])}:
                        </div>
                      </div>

                      {blockData ? (
                        <div style={{ display: 'flex', flexDirection: 'column', flex: 1, height: '60%', justifyContent: 'center', alignItems: 'center', textAlign: 'center', padding: '10px', backgroundColor: 'rgba(255, 152, 0, 0.05)', border: '2px dashed #ff9800', borderRadius: '8px', margin: '10px 0' }}>
                          <div style={{ fontSize: '30px', marginBottom: '10px' }}>⚠️</div>
                          <h2 style={{ color: '#ff9800', marginBottom: '10px', fontWeight: 'bold', fontSize: '18px' }}>Advertencia de Tiempo</h2>
                          <p style={{ color: 'var(--txt-color)', fontSize: '15px', marginBottom: '5px' }}>
                            El dispositivo lleva <strong>{blockData.down_minutes} minuto{blockData.down_minutes !== 1 ? 's' : ''}</strong> caído.
                          </p>
                          <p style={{ color: 'var(--txt-color)', fontSize: '15px', marginBottom: '15px' }}>
                            Tiempo de espera restante recomendado: <strong>{blockData.remaining_minutes} minuto{blockData.remaining_minutes !== 1 ? 's' : ''}</strong>.
                          </p>
                          <p style={{ color: '#d97706', fontSize: '16px', fontWeight: 'bold' }}>
                            ¿Deseas continuar?
                          </p>
                        </div>
                      ) : (
                        <>
                          <div className='contHeadTableAnalisis'>
                        <div className="compact-head-table-portafolio">
                          <div className='contCellHeadTableAnalisis' style={{ width: '15%' }}>
                            {capitalizeFirstLetter(lang[props.languaje]['tecnologia'])}
                          </div>
                          <div className='contCellHeadTableAnalisis' style={{ width: '15%' }}>
                            IP
                          </div>
                          <div className='contCellHeadTableAnalisis' style={{ width: '55%' }}>
                            {capitalizeFirstLetter(lang[props.languaje]['nombre'])}
                          </div>
                          <div className='contCellHeadTableAnalisis' style={{ width: '15%' }}>
                            {capitalizeFirstLetter(lang[props.languaje]['conectado'])}
                          </div>
                          {
                            (responseData.active) ?
                              <>
                                <div className='contCellHeadTableAnalisis' style={{ width: '15%' }}>
                                  {'Intermedio'}
                                </div>
                                <div className='contCellHeadTableAnalisis' style={{ width: '15%' }}>
                                  {'Final'}
                                </div>
                              </> : ''
                          }
                          {/* <div className='contCellHeadTableAnalisis' style={{width:'15%'}}>
                            {capitalizeFirstLetter(lang[props.languaje]['accion'])} 
                            </div> */}
                        </div>
                      </div>
                      <div className='contBodyTableAnalisis' style={{ height: '60%' }}>
                        {
                          (dataAnalisis.loading) ? <LoadSimple /> :
                            (responseData.active) ?
                              <div id={'contRowTableAnalisis'} className='row-table-portafolio'>
                                <div className='controwCellTableanalisis' style={{ width: '15%' }}>
                                  {responseData.data.message}
                                </div>
                              </div>
                              //   responseData.data.data.status_detail.map((element,index)=>(
                              //     <div id={'contRowTableAnalisis'+index} style={{background:(element.conectado &&  element.origen==1)?'var(--green)':((element.origen==1)?'var(--error-color)':''),color:(element.conectado &&  element.origen==1)?'var(--white-color)':((element.origen==1)?'var(--white-color)':'var(--txt-color)')}} className='row-table-portafolio'>
                              //     <div className='controwCellTableanalisis' style={{width:'15%'}}>
                              //         {element.tech_name}
                              //     </div>
                              //     <div className='controwCellTableanalisis'style={{width:'15%'}}>
                              //         {element.ip}
                              //     </div>
                              //     <div className='controwCellTableanalisis' style={{width:'55%'}}>
                              //         {element.host}
                              //     </div>
                              //     <div className='controwCellTableanalisis ' style={{width:'15%',color:(element.statusInicial)?'var(--green)':'red'}}>
                              //         {(element.statusInicial)?capitalizeFirstLetter(lang[props.languaje]['conectado']):capitalizeFirstLetter(lang[props.languaje]['desconectado'])}
                              //     </div>

                              //       <div className='controwCellTableanalisis ' style={{width:'15%',color:(element.statusIntermedio)?'var(--green)':'red'}}>
                              //         {(element.statusIntermedio)?capitalizeFirstLetter(lang[props.languaje]['conectado']):capitalizeFirstLetter(lang[props.languaje]['desconectado'])}
                              //     </div>
                              //     <div className='controwCellTableanalisis ' style={{width:'15%',color:(element.statusFinal)?'var(--green)':'red'}}>
                              //         {(element.statusFinal)?capitalizeFirstLetter(lang[props.languaje]['conectado']):capitalizeFirstLetter(lang[props.languaje]['desconectado'])}
                              //     </div>


                              // </div>
                              // ))
                              :
                              dataAnalisis.data.map((element, index) => (
                                <div id={'contRowTableAnalisis' + index} style={{ background: (element.conectado && element.origen == 1) ? 'var(--green)' : ((element.origen == 1) ? 'var(--error-color)' : ''), color: (element.conectado && element.origen == 1) ? 'var(--white-color)' : ((element.origen == 1) ? 'var(--white-color)' : 'var(--txt-color)') }} className='row-table-portafolio'>
                                  <div className='controwCellTableanalisis' style={{ width: '15%' }}>
                                    {element.tech_name}
                                  </div>
                                  <div className='controwCellTableanalisis' style={{ width: '15%' }}>
                                    {element.ip}
                                  </div>
                                  <div className='controwCellTableanalisis' style={{ width: '55%' }}>
                                    {element.host}
                                  </div>
                                  <div className='controwCellTableanalisis ' style={{ width: '15%', color: (element.conectado) ? 'var(--green)' : 'red' }}>
                                    {(element.conectado) ? capitalizeFirstLetter(lang[props.languaje]['conectado']) : capitalizeFirstLetter(lang[props.languaje]['desconectado'])}
                                  </div>

                                  {/* <div className='controwCellTableanalisis ' style={{width:'15%',color:(element.conectado)?'var(--green)':'red'}}>
                                {(element.conectado)?capitalizeFirstLetter(lang[props.languaje]['conectado']):capitalizeFirstLetter(lang[props.languaje]['desconectado'])}
                            </div>
                            <div className='controwCellTableanalisis ' style={{width:'15%',color:(element.conectado)?'var(--green)':'red'}}>
                                {(element.conectado)?capitalizeFirstLetter(lang[props.languaje]['conectado']):capitalizeFirstLetter(lang[props.languaje]['desconectado'])}
                            </div> */}

                                  {/* <div className='controwCellTableanalisis ' style={{width:'15%',color:(element.conectado)?'var(--green)':'red'}}>
                            <Action origen='Azul' disabled={true} titulo='RESET' action ={()=>{}}/>
                            </div> */}
                                </div>
                              ))
                        }


                      </div>
                        </>
                      )}
                      
                      <div className='allResetDevices'>
                        {/* <div style={{width:'40%',height:'100%',display:'flex'}}>
                            <div className='txtAllResetDevices'  style={{width:'70%'}}>
                              REINICIAR TODOS LOS DISPOSITIVOS:
                            </div>
                            <div className='txtAllResetDevices' style={{width:'20%'}}>
                            <Action origen='Azul' disabled={byHost} titulo='RESET' action ={()=>{openPingModal()}}/>
                            </div>
                            </div> */}
                        <div style={{ width: '100%', height: '100%', display: 'flex' }}>
                          <div className='txtAllResetDevices'>
                            Puede Seleccionar por dispositivo o TODOS los dispositivos relacionados:
                            {/* <div className='cont-checkbox' style={{width:'15%'}}>
                                <input type='checkbox' defaultChecked={props.poolRows.some((row) => row === props.data.eventid)} className='NotifiCheckBox ' style={{height:'15px',width:'40%'}}  onClick={(e)=>{setByHost(!byHost)}} ></input>
                              </div> */}
                          </div>
                          {(true) ?
                            <>
                              <div className='txtAllResetDevices' style={{ width: '40%', pointerEvents: (!byHost) ? 'none' : 'all' }} >
                                <div className="user-box-GS " style={{ height: '100%' }}>
                                  {
                                    (dataCatalog.loading) ? <LoadSimple /> :
                                      <SelectorAdmin placeholder={'Seleccionar nivel...'} opGeneral={true} txtOpGen={''} opt_de={0} origen={'bottom'} data={dataCatalog.data.data} loading={dataCatalog.loading} titulo='techtype' selectFunction={changeOption} index={0}></SelectorAdmin>

                                  }
                                </div>
                              </div>
                              <div className='txtAllResetDevices' style={{ width: '15%', left: '2%', position: 'relative' }}>
                                <Action origen='Azul' disabled={(byHost == false || techType.id == 0)} titulo='RESET' action={() => { openPingModal() }} />
                              </div>
                            </> : ''}
                        </div>
                      </div>

                    </div>
                  </>
            }
          </div>
        </div>
        <Modal
          isOpen={pingModalOpen}
          // onAfterOpen={afterOpenExeption}
          onRequestClose={closePingModal}
          style={customStylesAnalisis}
          contentLabel="Example Modal2"
        // shouldCloseOnOverlayClick={false}
        >
          {/* <MenuResetModal eventId={props.data.eventid} handleShowPopup={props.handleShowPopup} props={props} isOpen={pingModalOpen} data={props.data} statusPing={statusPing} closeActionModal={closePingModal}/> */}
          {/* <AnalisisModal eventId={props.data.eventid} props={props}></AnalisisModal> */}
          <ResetModal responseData={responseData} setResponseData={setResponseData} mode={''} byHost={byHost} techType={techType} handleShowPopup={props.handleShowPopup} server={props.server} isOpen={pingModalOpen} data={props.data} statusPing={statusPing} closeActionModal={closePingModal}></ResetModal>
          {/* <PingModal actionSelected={actionSelected} server={server}isOpen={pingModalOpen} data={data} statusPing={statusPing} closePingModal={closePingModal}></PingModal> */}
        </Modal>
      </>
  )
}

export default MenuResetModal
